import { Fragment, useEffect, useState } from "react";

const QuizExamQuestion = ({ index, isExpired, input, changeHandler }) => {
  const [selectedAnswer, setSelectedAnswer] = useState(undefined);

  useEffect(() => {
    if (!input) return;
    const ans = input.options?.find(o => o.isAnswer);
    setSelectedAnswer(ans?.id);
  }, [input]);

  if (!input) return null;

  return (
    <Fragment>
      <hr className="my-5" />

      <div className="px-4">
        <label className="block font-medium text-sky-700 dark:text-sky-300">
          {index + 1}. {input.question}
        </label>
      </div>

      <hr className="my-5" />

      {input.options.map((o, i) => (
        <label
          key={i}
          className={`flex items-center gap-3 px-4 py-2 rounded-md cursor-pointer
            ${selectedAnswer === o.id ? "text-green-600 font-medium" : ""}
          `}
        >
          <input
            type="checkbox"
            disabled={isExpired}
            checked={selectedAnswer === o.id}
            onChange={() => {
              setSelectedAnswer(o.id);
              changeHandler(input.id, o.id);
            }}
            className="w-5 h-5 accent-blue-500"
          />
          {o.option}
        </label>
      ))}

      <hr className="my-5" />
    </Fragment>
  );
};

export default QuizExamQuestion;
